import useSWR from "swr";
import { API } from "../utils/constants";
import { fetcher } from "./fetcher";

/**
 * useVehicles — Fetches all vehicles with current status and location.
 *
 * API: GET /api/vehicles → VehicleDto[] (CON-002 §3)
 *
 * @returns {{ vehicles: Array, error: any, isLoading: boolean }}
 */
export function useVehicles() {
  const { data, error, isLoading } = useSWR(
    API.VEHICLES.LIST,
    fetcher,
    { dedupingInterval: 30_000, revalidateOnFocus: false }
  );

  return { vehicles: data ?? [], error, isLoading };
}

/**
 * useVehicle — Fetches a single vehicle by ID.
 *
 * API: GET /api/vehicles/{id} → VehicleDto (CON-002 §3)
 *
 * @param {number|string|null} id
 * @returns {{ vehicle: object|null, error: any, isLoading: boolean }}
 */
export function useVehicle(id) {
  const { data, error, isLoading } = useSWR(
    id ? API.VEHICLES.DETAIL(id) : null,
    fetcher,
    { revalidateOnFocus: false }
  );

  return { vehicle: data ?? null, error, isLoading };
}
